import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import CustomSelect from '../../../components/customSelect';
import getEnvironement from '../../../environnement';
import axios from 'axios';
import CustomBackdrop from '../../../components/backdrop';
import { toast } from 'react-toastify';

export default function StatutDialog({
  open,
  handleClose,
  reloadData,
  message,
  getNotificationData
}) {
  const [statut, setStatut] = useState(message?.statut);
  const [statutError, setStatutError] = useState('');
  const [openBackdrop, setOpenBackdrop] = useState(false);

  async function editStatut() {
    const url = `${getEnvironement().API_URL}/messages/${message.id}`;
    const data = {
      statut
    };
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    handleClose();
    setOpenBackdrop(true);
    await axios.put(url, data, config)
      .then(() => setTimeout(() => setOpenBackdrop(false), 500))
      .then(() => reloadData())
      .then(() => getNotificationData())
      .then(() => toast.success(`Le statut du message ${message?.id} a bien été modifié`))
      .catch((err) => {
        setOpenBackdrop(false);
      });
  }

  useEffect(() => {
    if (open) {
      setStatut(message?.statut);
    }
  }, [message?.statut, open]);

  return (
    <>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{paddingBottom: '0px'}}
      >
        <DialogTitle id="alert-dialog-title">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Message : {message?.id}</p>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <CustomSelect
              items={[
                {id: 1, label: 'Traité', value: 'Traité'},
                {id: 2, label: 'Non traité', value: 'Non traité'},
              ]}
              placeholder='Statut'
              value={statut}
              setValue={setStatut}
              isError={statutError !== ''}
              error={statutError}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='flex justify-between px-5 w-full gap-5'>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={handleClose}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Annuler</p>
            </div>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 px-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={editStatut}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Confirmer</p>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
